export default __webpack_public_path__ + "static/media/woman-4.0715f209.png";